module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Frageboegen.0e79c68f.jpg";